module.exports = __webpack_public_path__ + "static/media/laxmirajB2.0272e827.png";